import { ErrorMessage } from 'types/error-message';

export const errorMessages: ErrorMessage[] = [
  {
    errorCode: 1451
  }
];
